// extracted by mini-css-extract-plugin
export default {"main_layout":"Login_main_layout__FFajH","login_form":"Login_login_form__s6kHo","layout_login_left":"Login_layout_login_left__Sg9IL","btn_login":"Login_btn_login__UvCc-"};